import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BizinBackend from "../../../helpers/bizin_helper";
import { Col, Row, Alert } from "reactstrap";
import NotificationModal from "../../../components/Common/NotificationModal";
import TableSimple from "../../../components/Dynamic/TableSimple";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import CalendarMultiMonth from "../../../components/Common/CalendarMultiMonth";
import { isLoading } from "../../../store/layout/actions";
import { DF_OT0011Context } from "../context";


function GridBodyFlowTwo() {
  const { access_token, csrfToken, userProfile, ID_Agendamento } = useContext(DF_OT0011Context);

  const dispatch = useDispatch(); 
  const preFilters = JSON.parse(localStorage.getItem('Prefilters'));

  const [step, setStep] = useState(1);
  const [idArquivo, setIdArquivo] = useState(null);

  const [agendaDisponivel, setAgendaDisponivel] = useState([])
  const [dataAgendaSelecionada, setDataAgendaSelecionada] = useState(null)
  const [horaAgendaSelecionada, setHoraAgendaSelecionada] = useState(null)
  const [modalConfirmacaoAberto, setModalConfirmacaoAberto] = useState(false)
  const [modalCreatedSchedule, setmodalCreatedSchedule] = useState(false)
  const [modalResultado, setModalResultado] = useState({ aberto: false, sucesso: false, mensagem: "", id: null, detalhes: null })

  const [isBlocked, setIsBlocked] = useState(false)

  const ID_DOCUMENTO_GRUPO = 2;

  // ================ NEW

  const handleCreatePreSchedule = async () => {
    try {
      const resp = await BizinBackend.executeProcedure(
        { 1: ID_Agendamento, 2: dataAgendaSelecionada.toLocaleDateString().split("/").reverse().join("-"), 3: horaAgendaSelecionada },
        "SRM_Pre_Agendamento_Atualizar",
        csrfToken,
        access_token
      )
     setmodalCreatedSchedule(true)
    } catch (error) {
      console.log("erro ao carregar [SRM_Pre_Agendamento_Atualizar]: ", error);
    }
  }

  const handleGetCalendar = async () => {
    try {
      const respAgenda = await BizinBackend.executeProcedure(
        { 1: ID_Agendamento },
        "FRONT_Workspace_DF_OT0011_Pre_Agendamento_Verifica_Agenda_Disponivel",
        csrfToken,
        access_token
      )

      console.log("respAgenda: ", respAgenda);
      
      if(respAgenda?.resultset_1 && respAgenda?.resultset_1.length > 0) setAgendaDisponivel(Array.isArray(respAgenda?.resultset_1) ? respAgenda?.resultset_1 : []);
      if(respAgenda?.resultset_2 && respAgenda?.resultset_2.length > 0) setIdArquivo(respAgenda?.resultset_2[0]?.ID_Arquivo);
    } catch (error) {
      console.log("erro ao carregar [SRM_Pre_Agendamento_Verifica_Agenda_Disponivel]: ", error);
    }
  }

  const dataHoraSelecionada =
          dataAgendaSelecionada && horaAgendaSelecionada
            ? `${dataAgendaSelecionada.toLocaleDateString("pt-BR")} ${horaAgendaSelecionada && `às ${horaAgendaSelecionada}`}`
            : "—";

  useEffect(() => {
    if (ID_Agendamento) {
      handleGetCalendar()
    }
  }, [ID_Agendamento])


  return (
    <div>
      {(() => {        
        const datasUnicas = Array.from(
          new Set(agendaDisponivel.map((a) => a?.Data_Agenda).filter(Boolean)),
        ).map((d) => {
          const [dia, mes, ano] = d.split("/");
          return new Date(`${ano}-${mes}-${dia}T00:00:00`);
        });

        const horariosDisponiveis = dataAgendaSelecionada
          ? agendaDisponivel
              .filter((a) => {
                const [dia, mes, ano] = (a?.Data_Agenda || "").split("/");
                const d = new Date(`${ano}-${mes}-${dia}T00:00:00`);
                return d.getTime() === dataAgendaSelecionada.getTime();
              })
              .map((a) => a?.Hora_Agenda)
          : [];

        const horariosUnicos = Array.from(new Set(horariosDisponiveis));        

        return (
          <>
            <Row className="mb-3">
              <Col lg={5} md={12} sm={12} className="mb-3">
                <div className="bg-white card-content shadow-card p-4 h-100">
                  <h3 className="text-color-cinza5 font-size-20 fw-semibold mb-3">
                    Selecione a data de entrega
                  </h3>
                  <CalendarMultiMonth
                    numberOfMonths={2}
                    selectedDates={dataAgendaSelecionada ? [dataAgendaSelecionada] : []}
                    availableDates={datasUnicas}
                    onChange={(dates) => {
                      const dataSelected = dates[dates.length - 1] || null;
                      setDataAgendaSelecionada(dataSelected);

                      // se a data seleciona não tiver habilitada para mostrar horários, então seta o primeiro horário disponível
                      if (dataSelected) {
                        const dataStr = `${String(dataSelected.getDate()).padStart(2, "0")}/${String(dataSelected.getMonth() + 1).padStart(2, "0")}/${dataSelected.getFullYear()}`;
                        const primeiro = agendaDisponivel.find((a) => a?.Data_Agenda === dataStr);
                        setHoraAgendaSelecionada(primeiro?.Hora_Agenda || null);
                      } else {
                        setHoraAgendaSelecionada(null);
                      }
                    }}
                  />
                </div>
              </Col>

              {horariosDisponiveis.length > 0 && (
                <Col lg={3} md={12} className="mb-3 p-lg-0">
                  <div className="bg-white card-content shadow-card p-4">
                    <h3 className="text-color-cinza5 font-size-20 fw-semibold mb-3">
                      Selecione o horário de entrega
                    </h3>
                    <div className="row g-2">
                      {horariosDisponiveis.map((h) => {
                        const habilitado = horariosUnicos.some((x) => (x || "").startsWith(h.slice(0, 2)));
                        const selecionado = horaAgendaSelecionada === h;
                        return (
                          <div key={h} className="col-4">
                            <button
                              type="button"
                              disabled={!habilitado}
                              onClick={() => setHoraAgendaSelecionada(h)}
                              className={`btn w-100 fw-semibold border-0 rounded-3 fw-regular ${
                                selecionado
                                  ? "btn-primary-dark text-white"
                                  : habilitado
                                  ? "bg-color-azul405 text-color-azul2"
                                  : "text-color-cinza4"
                              }`}
                              style={{height: 44,...(!habilitado && !selecionado && { backgroundColor: "#F1F1F1" })}}
                            >
                              {h}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Col>
              )}

              <Col lg={4} md={12} className={`mb-3 ${horariosDisponiveis.length === 0 && "ps-0"}`}>
                <div className="bg-white card-content shadow-card p-4">
                  <h3 className="text-color-cinza5 font-size-20 fw-semibold mb-3">
                    Confira o agendamento
                  </h3>
                  <Row>
                    <Col md={6} className="mb-3">
                      <div className="text-muted small">Tipo de Veículo</div>
                      <div className="fw-semibold text-color-cinza5">
                        {preFilters[0]?.["Filtro_ID_Veiculo"]?.label || "—"}
                      </div>
                    </Col>
                    <Col md={6} className="mb-3">
                      <div className="text-muted small">Data e Hora de Entrega</div>
                      <div className="fw-semibold text-color-cinza5">{dataHoraSelecionada}</div>
                    </Col>
                    <Col md={6} className="mb-3">
                      <div className="text-muted small">Tipo de Entrega</div>
                      <div className="fw-semibold text-color-cinza5">
                        {preFilters[0]?.["Filtro_ID_Tipo_Entrega"]?.label || "—"}
                      </div>
                    </Col>
                    <Col md={6} className="mb-3">
                      <div className="text-muted small">Destino</div>
                      <div className="fw-semibold text-color-cinza5">
                        {preFilters[0]?.["Filtro_ID_Empresa_Destino"]?.label || "—"}
                      </div>
                    </Col>
                    <Col md={6} className="mb-3">
                      <div className="text-muted small">Categoria</div>
                      <div className="fw-semibold text-color-cinza5">
                        {preFilters[0]?.["Filtro_ID_Categoria"]?.label || "—"}
                      </div>
                    </Col>
                    <Col md={6} className="mb-3">
                      <div className="text-muted small">Local de Entrega</div>
                      <div className="fw-semibold text-color-cinza5 text-break">
                        {preFilters[0]?.["Filtro_ID_Local_Entrega"]?.field || "—"}
                      </div>
                    </Col>
                    <Col md={6} className="mb-3">
                      <div className="text-muted small">Agendamento</div>
                      <div className="fw-semibold text-color-cinza5 text-break">
                        {ID_Agendamento || "—"}
                      </div>
                    </Col>
                  </Row>
                  <Alert className="border-0 m-0 mt-2" style={{ backgroundColor: "#FECE2226" }}>
                    <div className="row p-2 px-3">
                      <div className="col-auto p-0 pe-3">
                        <i className="fas fa-exclamation-triangle text-warning font-size-20"></i>
                      </div>
                      <div className="col p-0">
                        <span className="text-color-amarelo2 fw-semibold font-size-14">
                          ATENÇÃO:
                        </span>{" "}
                        <span className="text-color-amarelo2 font-size-14">
                          Não se esqueça de confirmar seu agendamento até 3 dias antes da entrega!
                        </span>
                      </div>
                    </div>
                  </Alert>
                </div>
              </Col>
            </Row>

            <div className="row mt-2 mb-3">
              <div className="col-6 d-flex justify-content-start">
                <button
                  className="btn bg-white border border-color-cinza2 text-color-azul1 fw-bold px-4"
                  onClick={() => window.location.href = "/DF_OT0011"}
                >
                  Voltar
                </button>
              </div>
              <div className="col-6 d-flex justify-content-end">
                <button
                  className={`btn fw-semibold px-4 ${
                    dataAgendaSelecionada && horaAgendaSelecionada
                      ? "btn-primary-dark text-white"
                      : "disabled bg-color-cinza2 text-color-cinza4 border border-color-cinza2"
                  }`}
                  disabled={!dataAgendaSelecionada || !horaAgendaSelecionada}
                  onClick={() => setModalConfirmacaoAberto(true)}
                >
                  Finalizar pré-agendamento
                </button>
              </div>
            </div>
          </>
        );
      })()}

      <NotificationModal
        isOpen={modalConfirmacaoAberto}
        type="warning"
        titleCustom="Deseja criar o pré-agendamento?"
        message="Ao clicar em 'Confirmar' o pré-agendamento será criado."
        confirmButton
        onClose={() => setModalConfirmacaoAberto(!modalConfirmacaoAberto)}
        onConfirm={handleCreatePreSchedule}
      />

      <NotificationModal
        isOpen={modalCreatedSchedule}
        type="success"
        titleCustom="Sucesso!"
        hasButtonCustom        
      >
        <div className="bg-color-branco3 p-3 rounded-3 d-flex gap-2 flex-column mb-3">
          <div className="d-flex align-items-center gap-1 justify-content-start w-100">
            <i className="fa-solid fa-file text-color-azul2 font-size-16"></i>
            <span className="font-size-14 fw-semibold text-color-azul2">Protocolo:</span>
            <span className="font-size-14 fw-regular text-color-cinza5">{ID_Agendamento}</span>
          </div>
          <div className="d-flex align-items-center gap-1 justify-content-start w-100">
            <i className="fa-regular fa-clock text-color-azul2 font-size-16"></i>
            <span className="font-size-14 fw-semibold text-color-azul2">Data e Hora de Entrega:</span>
            <span className="font-size-14 fw-regular text-color-cinza5">{dataHoraSelecionada}</span>
          </div>
          <div className="d-flex align-items-center gap-1 justify-content-start w-100">
            <i className="fa-solid fa-location-dot text-color-azul2 font-size-16"></i>
            <span className="font-size-14 fw-semibold text-color-azul2">Local de Entrega:</span>
            <span className="font-size-14 fw-regular text-color-cinza5">{preFilters[0]?.["Filtro_ID_Local_Entrega"]?.field}</span>
          </div>
          <div className="d-flex align-items-center gap-1 justify-content-start w-100">
            <i className="fa-solid fa-truck-moving text-color-azul2 font-size-16"></i>
            <span className="font-size-14 fw-semibold text-color-azul2">Local de Desembarque:</span>
            <span className="font-size-14 fw-regular text-color-cinza5">{preFilters[0]?.["Filtro_ID_Empresa_Destino"]?.label}</span>
          </div>
          <div className="d-flex align-items-center gap-1 justify-content-start w-100">
            <span className="font-size-14 fw-semibold text-color-vermelho1">Respeite os horários do local de entrega. Não se esqueça de confirmar seu agendamento até 3 dias antes!</span>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-primary-dark"
          onClick={() => window.location.href = `/BI_WS0025?ID_Arquivo=${idArquivo}`}
        >
          Imprimir Protocolo
        </button>
      </NotificationModal>
    </div>
  )
}

export default GridBodyFlowTwo;
